const CarouselList = () => import('@/vuepage/content-manage/carouselList')
const AddCarousel = () => import('@/vuepage/content-manage/addCarousel')
const FriendlyLink = () => import('@/vuepage/content-manage/friendlyLink')
const IndustryCase = () => import('@/vuepage/content-manage/industryCase')
export default [
    {
        path: '/carousel-list',
        component: CarouselList,
        name: '/carousel-list',
        meta: [
            { name: '内容管理' },
            { name: '轮播图管理', activeRoute: '/carousel-list' }
        ]
    },
    {
        path: '/add-carousel',
        component: AddCarousel,
        name: '/add-carousel',
        meta: [
            { name: '内容管理' },
            { name: '新增/编辑轮播图', activeRoute: '/add-carousel' }
        ]
    },

    {
        path: '/friendly-link',
        component: FriendlyLink,
        name: '/friendly-link',
        meta: [{
            name: '内容管理'
        }, {
            name: '友情链接管理',
            activeRoute: '/friendly-link'
        }]
    },

    {
        path: '/industry-case',
        component: IndustryCase,
        name: '/industry-case',
        meta: [{
            name: '内容管理'
        }, {
            name: '行业方案管理',
            activeRoute: '/industry-case'
        }]
    }

]
